'use client';

import { generatePresignedPost } from '@/actions/s3';
import { Button } from '@spikemark/ui/components/design-system/button';
import { Input } from '@spikemark/ui/components/ui/input';
import { LoadingSpinner } from '@spikemark/ui/components/loading-spinner';
import { Mascot } from '@spikemark/ui/components/mascot';
import { useCallback, useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
export const LogoUpload = ({
  text,
  altText,
  value,
  onChange,
  disabled,
  mode = 'team',
  ...restProps
}: {
  text?: string;
  altText: string;
  value: string;
  onChange: (logoUrl: string) => void;
  disabled?: boolean;
  mode?: 'team' | 'player';
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const handleChange = useCallback(() => {
    if (!inputRef.current) {
      return;
    }
    const files = inputRef.current.files;
    if (!files || files.length !== 1) {
      return;
    }
    setIsUploading(true);
    const readKey = `upload/${altText.replaceAll(' ', '') ?? 'new-media'}-${uuid()}`;
    generatePresignedPost(`static/images/${readKey}`).then(async ({
      url,
      fields
    }) => {
      const body = new FormData();
      Object.entries(fields).forEach(([k, v]) => {
        body.append(k, v);
      });
      body.append('file', files[0]);
      await fetch(url, {
        body,
        method: 'POST'
      });
      onChange(readKey);
      setIsUploading(false);
    });
  }, [altText, onChange]);
  return <div className="flex items-center" data-sentry-component="LogoUpload" data-sentry-source-file="logo-upload.tsx">
      <div className="relative">
        <Mascot alt={altText} variant="input" displayMode={mode} path={value} data-sentry-element="Mascot" data-sentry-source-file="logo-upload.tsx" />
        {isUploading && <div className="absolute inset-0 flex items-center justify-center bg-white rounded-full">
            <LoadingSpinner width={60} />
          </div>}
      </div>
      <Input {...restProps} className="hidden" data-sentry-element="Input" data-sentry-source-file="logo-upload.tsx" />
      <Button variant="outlineBlue" className="ml-4" type="button" onClick={() => inputRef.current?.click()} disabled={disabled} data-sentry-element="Button" data-sentry-source-file="logo-upload.tsx">
        <input type="file" accept={['image/jpeg', 'image/png'].join(',')} className="sr-only" ref={inputRef} onChange={handleChange} />
        {text ?? 'Upload Logo'}
      </Button>{' '}
    </div>;
};